import { Button, FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import { CreditCard } from 'lucide-react';
import { useState } from 'react';
import { SettingsSectionRow } from 'src/components/SettingsSection';
import { SUPPORTED_COUNTRIES } from './constants';
import { useStripeAccountOnboardUrl } from './use-stripe-account-onboard-url';

/**
 * Row shown when the partner has no Stripe account yet: pick a country and
 * hand off to Stripe-hosted onboarding.
 */
export const StripeSetupRow = () => {
  const { redirectToStripeOnboard, loading } = useStripeAccountOnboardUrl();
  const [country, setCountry] = useState<string>('US');

  return (
    <SettingsSectionRow
      icon={<CreditCard />}
      title="Stripe Express account"
      secondary="You'll be redirected to Stripe to complete onboarding."
      control={
        <Stack direction="row" alignItems="center" gap={1.5}>
          <FormControl
            size="small"
            sx={{ minWidth: (theme) => theme.typography.pxToRem(180) }}
          >
            <InputLabel id="stripe-country-label">Country</InputLabel>
            <Select
              labelId="stripe-country-label"
              id="stripe-country-select"
              value={country}
              label="Country"
              onChange={(e) => setCountry(e.target.value)}
            >
              {SUPPORTED_COUNTRIES.map((c) => (
                <MenuItem key={c.value} value={c.value}>
                  {c.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            variant="contained"
            onClick={() => void redirectToStripeOnboard(country)}
            disabled={loading}
          >
            {loading ? 'Connecting...' : 'Connect with Stripe'}
          </Button>
        </Stack>
      }
      controlAlign="center"
      mobileControlLayout="below"
    />
  );
};
